module.exports = __webpack_public_path__ + "static/img/gacetaboficia.91d08d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gacetaboficia.png
// module id = LZQy
// module chunks = 9